import React from 'react';

// Material
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

// Components
import TextField from '../../../../../components/inputs/input';

// Models
import { subTypesFormat } from '../../../../../models/CashRegisterMovementEntity';


const DetailEgress = ({ onClose, open, cashRegisterMovement }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            maxWidth='sm'
        >
            <DialogTitle id="alert-dialog-title">
                { cashRegisterMovement.subTypeFormat === subTypesFormat.Imprest ? `Egreso de ${subTypesFormat.Imprest}` : `Egreso de Caja${cashRegisterMovement.subTypeFormat ? ` (${cashRegisterMovement.subTypeFormat})` : ''}` }
            </DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2}>
                        {
                            cashRegisterMovement.bankAccountInfo &&
                            <Grid size={12}>
                                <TextField
                                    fullWidth
                                    size='small'
                                    name='bankAccountInfo'
                                    label='Cuenta bancaria'
                                    value={cashRegisterMovement.bankAccountInfo || ''} 
                                    disabled
                                />
                            </Grid>
                        }
                        <Grid size={4}>
                            <TextField
                                fullWidth
                                size='small'
                                name='cashType'
                                label='Tipo de efectivo'
                                value={cashRegisterMovement.cashTypeFormat}
                                disabled
                            />
                        </Grid>
                        <Grid size={8}>
                            <TextField
                                fullWidth
                                size='small'
                                name='amount'
                                label='Importe'
                                type='number'
                                value={cashRegisterMovement.amount} 
                                disabled
                            />
                        </Grid>
                        {
                            cashRegisterMovement.reason &&
                            <Grid size={12}>
                                <TextField
                                    fullWidth
                                    size='small'
                                    name='reason'
                                    label='Motivo'
                                    value={cashRegisterMovement.reason || ' '}
                                    disabled
                                />
                            </Grid>
                        }
                        <Grid size={12}>
                            <TextField
                                fullWidth
                                multiline
                                rows={5}
                                size='small'
                                name='observation'
                                label='Observación'
                                value={cashRegisterMovement.observation || ''} 
                                disabled
                            />
                        </Grid>
                        {
                            cashRegisterMovement.fileUrl &&
                            <Grid size={12}>
                                <a href={cashRegisterMovement.fileUrl} target='_blank' rel="noreferrer" style={{ marginLeft: "10px", marginTop: "15px", display: "flex", alignItems: "center" }}>
                                    <img src={cashRegisterMovement.fileUrl} style={{ maxHeight: "200px", maxWidth: "200px", marginLeft: "5px" }} alt="" />
                                </a>
                            </Grid>
                        }
                    </Grid>
            </DialogContent>
            <DialogActions>
                <Button 
                    onClick={onClose} 
                    color="primary"
                >
                    Cerrar
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default DetailEgress;